const faqData = [
  {
    question: '酷看漫画上的所有内容都是免费的吗？',
    answer: '是的！酷看漫画平台上的所有漫画内容均免费提供在线阅读，无需注册或付费即可浏览。我们的目标是为漫画爱好者打造一个纯粹的漫画发现和阅读平台，不设置任何付费墙或隐藏收费项目。',
  },
  {
    question: '韩漫、日漫、国漫都有什么区别？',
    answer: '韩漫通常以全彩条漫形式呈现，画风精致，题材偏向恋爱、玄幻和职场；日漫以黑白页漫为主，分镜和剧情表现力极强，类型覆盖最为广泛；国漫近年来发展迅速，融合了传统中国风与现代漫画技法，玄幻和历史题材尤为出色。酷看漫画将三者分类整理，方便你按喜好浏览。',
  },
  {
    question: '如何快速找到我想看的漫画类型？',
    answer: '你可以通过首页顶部的分类索引快速进入想要看的漫画类型板块，也可以使用排行榜查看当前最热门的作品。每个漫画都有详细的类型标签（玄幻、恋爱、热血等），点击标签即可浏览该类型下的所有作品。',
  },
  {
    question: '漫画更新频率是怎样的？',
    answer: '不同漫画的更新频率因作品而异，热门连载通常每周更新1-2话。酷看漫画编辑团队会每日追踪全网热门漫画的更新动态，在首页「更新动态」板块及时展示最新更新的作品信息，让你不错过任何追更进度。',
  },
];

export default function FAQ() {
  return (
    <section id="faq" className="py-12 md:py-16 bg-background-100">
      <div className="max-w-[900px] mx-auto px-4 md:px-6">
        <div className="text-center mb-8 md:mb-10">
          <h2 className="text-xl md:text-2xl font-black text-foreground-950 mb-2">常见问题</h2>
          <p className="text-sm text-foreground-500">关于酷看漫画，你想知道的都在这里</p>
        </div>

        <div className="space-y-3">
          {faqData.map((faq, i) => (
            <div key={i} className="rounded-xl bg-background-50 p-5">
              <h3 className="text-sm md:text-base font-bold text-foreground-900 mb-2">
                {faq.question}
              </h3>
              <p className="text-sm text-foreground-600 leading-relaxed">
                {faq.answer}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}